import React from "react";
import LearnMore from "./LearnMore";

export default function ThankYou() {
  return (
    <div className="intro center">
      <h1>Thank you for registering</h1>
      <p>
        We will collect votes for Joe Biden's VP until he announces his running
        mate. His campaign has said that this will occur on or before August 1
        <sup>st</sup>. Once we've crunched the numbers, we'll send you an email
        with an analysis of the election results. We will also include an invite
        to a panel live panel discussion of the election results and related
        thoughts about these alternative voting methods.
      </p>
      <LearnMore />
    </div>
  );
}
